import { Component, Injector, Input, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGridComponent } from 'src/modules/base/components/form-grid/form-grid.component';
import { AsideBarService } from 'src/modules/base/services/asideBar.service';

@Component({
    selector: 'onboarding-form-grid',
    templateUrl: '../../../base/components/form-grid/form-grid.component.html',
    styleUrls: ['./onboarding-form-grid.component.scss'],
    standalone: false
})
export class OnboardingFormGridComponent extends FormGridComponent implements OnInit {
  @Input() gridParams: any;
  constructor(public route: ActivatedRoute, public injector: Injector, router: Router, public asideBarservice: AsideBarService) {
    super(route, injector, router, asideBarservice)
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['gridParams'].isFirstChange()) {
      if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
        this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
      } else {
        this.bindGrid();
      }
    }
  }

  initFormList() {
    this._currentData.configList = {
        "viewAll": true,
        "hideSearchBox": false,
        "hideResult": false,
        "allowPagination": true,
        "customButtonsAllowed":true
    }
    this._currentData.config = {
        "submitButton": true,
        "cancelButton": true,
        "filterForm": false,
        "clearOnSave": false,
        "delegateSave": true,
        "cancelRoute": ''
    }
}

  bindGrid(resource?, application?, type?, queryId?) {
    this.loader.showSpinner();
    var gridData = JSON.parse(JSON.stringify(this._currentData.gridData));//making a clone
    if (Object.keys(this.gridParams).length > 0) {
      if (this.gridParams.filter != undefined && this.gridParams.filter != '') {
        if (gridData['filter'] != '')
          gridData['filter'] += ',' + this.gridParams.filter
        else
          gridData['filter'] += this.gridParams.filter
      }
      if (this.gridParams.args != undefined && this.gridParams.args != '') {
        if (gridData['args'] != '')
          gridData['args'] += ',' + this.gridParams.args
        else
          gridData['args'] += this.gridParams.args
      }
    }
    if (this._currentData.parameters) {
      gridData['parameters'] = this._currentData.parameters;
    }

    if (queryId == undefined || queryId == '') {
      gridData['query_id'] = this._currentData.resouceDef.query_id == undefined ? "GET_PAGE" : this._currentData.resouceDef.query_id;
    } else { gridData['query_id'] = queryId == undefined ? "GET_PAGE" : queryId; }

    if (this._currentData.APIresource) {
      resource = this._currentData.APIresource.resource;
      application = this._currentData.APIresource.application;
      gridData['query_id'] = this._currentData.APIresource.query_id;
    }
    resource = (resource == '' || resource == undefined) ? this._currentData.resource : resource;
    this.baseService.getData(gridData, "", resource, application).subscribe(
      (data: any) => {
        if (data.erroCode == -1) {
          this.alerts.error(data.message);
          if (type == undefined || type == '') {
            this._currentData.dataList = [];
          }

        } else {
          if (type == undefined || type == '') {
            this._currentData.dataList = data;
          }
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
      }
    );
  }

  saveData(event) {
    if (this.route.snapshot.queryParams.hasOwnProperty('selectedFacility')) {
      event.result['facility_id'] = this.route.snapshot.queryParams.selectedFacility
    }
    super.saveData(event)
  }

}
